import React, {useEffect} from 'react';
import {
    Button,
    Row,
    Col,
    Table,
    InputGroup,
    FormControl,
    Form,
    ButtonGroup,
    Spinner
} from 'react-bootstrap';
import {FaPlusCircle, FaKey, FaTrashAlt, FaRegCopy} from 'react-icons/fa';
import {Input} from "reactstrap";
import * as MasterCompanyModels from "../../../models/company/MasterCompany";
import EmailConfigViewmodel from "./EmailConfig.viewmodel";


export default function EmailConfig() {
    const {isLoading, emailConfigs} = EmailConfigViewmodel()

    return (
        <div>
            <div className="master-data-content">
                <div
                    className="trapezoid-head"
                    style={{width: '200px'}}
                >
                    <span>Email Config</span>
                </div>

                <div className="mat-box">
                    <Row>
                        <Col>
                            <div className="container">
                                <div
                                    className="trapezoid trapezoid-purple"
                                    style={{
                                        display: 'inline-block',
                                        width: 'fit-content'
                                    }}
                                >
                                    <span>
                                        <i
                                            className="fa fa-search"
                                            aria-hidden="true"
                                        ></i>
                                        Email Config
                                    </span>
                                </div>
                                {/*<div*/}
                                {/*    style={{*/}
                                {/*        display: 'inline-block',*/}
                                {/*        float: 'right'*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*    <Button*/}
                                {/*        className="mx-2"*/}
                                {/*        variant="outline-info"*/}
                                {/*        size="sm"*/}
                                {/*        onClick={() => {*/}
                                {/*        }}*/}
                                {/*    >*/}
                                {/*        <FaPlusCircle/>*/}
                                {/*        &nbsp;Save*/}
                                {/*    </Button>*/}
                                {/*</div>*/}

                                <Table
                                    className="table-bordered table-responsive-sm table-hover table-sm table align-middle"
                                    size="sm"
                                >
                                    {/*<colgroup>*/}
                                    {/*    <col className="w-auto"/>*/}
                                    {/*    <col className="w-auto"/>*/}
                                    {/*    <col className="w-auto"/>*/}
                                    {/*    <col className="w-auto"/>*/}
                                    {/*    <col className="w-auto"/>*/}
                                    {/*    <col className="w-full"/>*/}
                                    {/*</colgroup>*/}
                                    <thead>
                                    <tr className="text-center">
                                        <th style={{width: "30%"}}
                                        >Config
                                        </th>
                                        {/*<th>wftypr</th>*/}
                                        {/*<th>wfcondition</th>*/}
                                        {/*<th>emailcc</th>*/}
                                        {/*<th>emailbcc</th>*/}
                                        <th style={{width: '70%'}}
                                        >Content
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {isLoading
                                       ?
                                        <tr>
                                            <td colSpan={4} style={{ background: "rgba(209, 250, 221, 1)", color: "black", fontSize: '10pt', textAlign: "center" }}>
                                                <Spinner animation="border" size="sm" />
                                                &nbsp;&nbsp;Loading...
                                            </td>
                                        </tr>
                                        : <tr></tr>}

                                    {emailConfigs && emailConfigs.map((emailConfig, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="flex flex-col gap-1 w-full">
                                                    <InputGroup>
                                                        <Form.Group className="w-full" controlId="formBasicEmail">
                                                            <Form.Label>
                                                                SID :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="sid"
                                                                value={emailConfig.sid}
                                                                readOnly
                                                            />

                                                            <Form.Label className="mt-3">
                                                                WF TYPE :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="wftype"
                                                                value={emailConfig.wftype}
                                                                readOnly
                                                            />

                                                            <Form.Label className="mt-3">
                                                                WF CONDITION :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="wfcondition"
                                                                value={emailConfig.wfcondition}
                                                                readOnly
                                                            />

                                                            <Form.Label className="mt-3">
                                                                Email CC :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="emailcc"
                                                                value={emailConfig.emailcc}
                                                                readOnly
                                                            />

                                                            <Form.Label className="mt-3">
                                                                Email BCC :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="emailbcc"
                                                                value={emailConfig.emailbcc}
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </InputGroup>
                                                </div>
                                            </td>
                                            <td className="w-full min-w-0">
                                                <div className="flex flex-col w-full px-4">
                                                    <Form.Label className="">
                                                        Subject :
                                                    </Form.Label>
                                                    <div
                                                        className="w-full form-control bg-[#e9ecef] hover:none text-sm prose max-w-none px-4"
                                                        dangerouslySetInnerHTML={{__html: emailConfig.contentsubject}}
                                                    />
                                                    <Form.Label className="mt-3">
                                                        Body :
                                                    </Form.Label>
                                                    <div
                                                        className="w-full text-sm prose max-w-none"
                                                        dangerouslySetInnerHTML={{__html: emailConfig.contentbody}}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}
